// extracted by mini-css-extract-plugin
export default {"icon":"styles_icon__BuSRb","container":"styles_container__qL108"};